import { render, staticRenderFns } from "./postCard.component.vue?vue&type=template&id=4f0c2ba6&scoped=true&"
import script from "./postCard.component.vue?vue&type=script&lang=js&"
export * from "./postCard.component.vue?vue&type=script&lang=js&"
import style0 from "./postCard.component.vue?vue&type=style&index=0&id=4f0c2ba6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c2ba6",
  null
  
)

export default component.exports